import { REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_HEADER_ACTIONS_VISIBILITY } from './RequestProfileWidgetDwellersAndLandlordsHeaderActions.constants'

export function isRequestProfileWidgetDwellersAndLandlordsVisibilityVisible(
  visibility
) {
  return (
    visibility ===
    REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_HEADER_ACTIONS_VISIBILITY.visible
  )
}

export function getRequestProfileWidgetDwellersAndLandlordsVisibilityType(
  isVisibleToDwellers
) {
  return isVisibleToDwellers
    ? REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_HEADER_ACTIONS_VISIBILITY.visible
    : REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_HEADER_ACTIONS_VISIBILITY.hidden
}

export function getRequestProfileWidgetDwellersAndLandlordsVisibilityTooltipKey(
  visibilityType
) {
  return visibilityType ===
    REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_HEADER_ACTIONS_VISIBILITY.visible
    ? 'RequestProfile.DwellersAndLandlordsWidgetPublicTooltipKey'
    : 'RequestProfile.DwellersAndLandlordsWidgetPrivateTooltipKey'
}
